import getPlayer from '../../../../Apis/player/getPlayer'

const playerStatsBreadcrumb = async (data) => {
  const { match, pairedOrgId } = data || {}
  const { playerId } = match.params

  // A paired club's Org-Id is its own org, where the federation's player is not: read it under the federation's route.
  const playerName = await getPlayer({ playerId, orgId: pairedOrgId }).then((player) => {
    return `${player?.personalData?.firstName} ${player?.personalData?.lastName}`
  })

  return ['PLAYER STATS', playerName ? playerName.toUpperCase() : '']
}

export default playerStatsBreadcrumb
